import { render, staticRenderFns } from "./alertPanelSwitcher.vue?vue&type=template&id=d7661f82&scoped=true&lang=pug"
import script from "./alertPanelSwitcher.vue?vue&type=script&lang=js"
export * from "./alertPanelSwitcher.vue?vue&type=script&lang=js"
import style0 from "./alertPanelSwitcher.vue?vue&type=style&index=0&id=d7661f82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7661f82",
  null
  
)

export default component.exports